var submitACaseFormPagesVisited = [];
var isSubmitACaseFormLoaded = false;
var submitACaseHideFields = '';

function hideFieldsAndAddLoading(form) {
    form.find('.frm_fields_container').css('visibility', 'hidden');
    form.find('.frm_fields_container').before('<div class="ta-c"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');
    $([document.documentElement, document.body]).animate({
        scrollTop: form.offset().top - 200
    }, 500);
}

function adjustFooterColumns() {
    var footerCols = $('#menu-menu-footer>.menu-item');

    /*
    *  The third column gets out of order, because the second has less height than the first.
    *  Update the second column height
    */
    var secondElemHeight = 0; // Get the element height. On "window resize" it may be larger, so find the children height
    $(footerCols[1]).children().each(function(i, el){
        secondElemHeight += el.offsetHeight;
    });

    if (secondElemHeight < footerCols[0].offsetHeight) {
        footerCols[1].style.height = footerCols[0].offsetHeight + 'px';
    }
}

function adjustInformationTabsWidth() {
    var tabWrapper = $('.tab-wrapper .tabset');
    if (tabWrapper.length) {
        var tabItems = tabWrapper.find('li');
        var prevTabPos = 0;
        for (var i = 0; i < tabItems.length; i++) {
            // start with clear class
            $(tabItems[i]).removeClass('tab-grow');
            var currTabPos = $(tabItems[i]).offset().left;
            if (prevTabPos >= currTabPos) {
                // detected new row
                // make previous item grow
                $(tabItems[i-1]).addClass('tab-grow');
            }
            prevTabPos = currTabPos;
        }
        // always grow last item
        $(tabItems[tabItems.length - 1]).addClass('tab-grow');
    }
}

function autoCompleteAddress(additionalCityInput, additionalStateInput) {
    var autoCompleteForm = $('form.form-default');
    if (autoCompleteForm.length) {
        var addressInput = document.querySelector('.lumina-address');
        if (addressInput !== null) {
            var address = new google.maps.places.Autocomplete(addressInput, {
                componentRestrictions: {country: "us"}
            });
            address.addListener('place_changed', function() {
                var place = address.getPlace();
                var cityState = '';
                var address1 = {
                    stNum: '',
                    route: '',
                    region: '',
                    getAddr: function () {
                        var x = this.stNum + ' ' + this.route;
                        if (this.region) {
                            x += ', ' + this.region;
                        }

                        return x.trim();
                    }
                };

                if (!place.geometry) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    return;
                }

                if (!place.address_components.length) {
                    return;
                }

                place.address_components.forEach(function(element) {
                    if (element.types.indexOf("administrative_area_level_1") != -1) {
                        if (cityState.length && cityState.charAt(cityState.length-1) != '/') {
                            cityState += ', ';
                        }
                        cityState += element.short_name;
                        setValueAndReValidate(autoCompleteForm.find('.lumina-state'), element.short_name);
                        if (additionalStateInput) {
                            setValueAndReValidate(autoCompleteForm.find(additionalStateInput), element.short_name);
                        }
                    }

                    if (element.types.indexOf("locality") != -1 || element.types.indexOf("sublocality_level_1") != -1) {
                        if (cityState.length) {
                            cityState += ', ';
                        }
                        cityState += element.short_name;
                        setValueAndReValidate(autoCompleteForm.find('.lumina-city'), element.long_name);
                        if (additionalCityInput) {
                            setValueAndReValidate(autoCompleteForm.find(additionalCityInput), element.long_name);
                        }
                    }

                    if (element.types.indexOf("postal_code") != -1) {
                        setValueAndReValidate(autoCompleteForm.find('.lumina-zip'), element.long_name);
                    }

                    if (element.types.indexOf("street_number") != -1) {
                        address1.stNum = element.long_name;
                    }

                    if (element.types.indexOf("route") != -1) {
                        address1.route = element.long_name;
                    }

                });

                setValueAndReValidate(autoCompleteForm.find('.lumina-city-state'), cityState);
                setValueAndReValidate(autoCompleteForm.find('.lumina-address'), address1.getAddr());
            });
        }
    }
}

function setValueAndReValidate(element, value) {
    if (element.length) {
        element.val(value);
        element.parsley().validate();
    }
}

function conditionalOtherInput(master, slave, value) {
    master.on('change', function() {
        if ($(this).val() === value) {
            slave.closest('.form-field').show();
        } else {
            slave.closest('.form-field').hide();
        }
    });
}

/*
 * The <select> color is set to placeholder
 * When the user selects an option, set the <select> color to the option color
 */
function addPlaceholderOnSelect(elements) {
    elements.change(function(){
        var me = $(this);
        var options = me.find('option');
        me.css('color', options.css('color'));
        me.css('font-weight', options.css('font-weight'));
    });
    // If the select has a default value, trigger the placeholder color change
    elements.each(function(){
        var me = $(this);
        if (me.val() !== "") {
            me.trigger('change');
        }
    });
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setFirstAndLastFromFullName(full_name, first_name, last_name) {
    var full_name_val = $(full_name).val().trim().split(" ");

    var first_name_val = full_name_val[0];
    var last_name_val = '';

    for (var i = 1; i < full_name_val.length; i++) {
        if (i < full_name_val.length - 1) {
            last_name_val += full_name_val[i] + ' ';
        } else {
            last_name_val += full_name_val[i];
        }
    }

    $(first_name).val(first_name_val);
    $(last_name).val(last_name_val);
}

function isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function loadInstagram(instagramSection) {
    instagramSection.append('<script type="text/javascript" src="' + script_options.plugins_url + '/instagram-feed/js/sb-instagram.min.js?ver=1.10.2"></script>');
}

function trackVisitedPage(form) {
    var current_page = form.find('.frm_current_page input').val();
    var isCurrentPageVisited = false;
    submitACaseFormPagesVisited.forEach(function(elem) {
        
        if (elem === current_page) {
            isCurrentPageVisited = true;
        }
        if (elem > current_page) {
            var visitedLink = form.find('.frm_rootline input[value="' + elem + '"]');
            if (visitedLink.length) {
                var li = visitedLink.closest('li');
                li.addClass('frm_visited_page');
                li.find('input').prop('disabled', false);
            }
        }

        console.log('elem'+elem,'cpage'+current_page);
    });
    if (!isCurrentPageVisited) {
        submitACaseFormPagesVisited.push(current_page);
    }
}

function checkSubmitACaseFormLoaded() {
    /*
     * Must wait till the form loads the conditions for the Hidden Fields
     * In some cases, the js is not loaded fast enough, the form displays all hidden fields
     */
    if (submitACaseHideFields) {
        var frmHideFieldsVal = submitACaseHideFields.val();
        if (frmHideFieldsVal.length) {
            isSubmitACaseFormLoaded = true;
        }
    }

    /*
     * If the form is not ready, check again in 200 ms
     */
    if (isSubmitACaseFormLoaded === false) {
        window.setTimeout(checkSubmitACaseFormLoaded, 200);
    } else {
        var formContainer = $('.submit-a-case-form-container');
        formContainer.removeClass('form-loading');
    }
}

function addParsleyLabelClasses() {
    window.Parsley.on('field:success', function() {
        var label = this.$element.closest('.frm_form_field').find('label');
        label.addClass('parsley-success').removeClass('parsley-error');
    });
    window.Parsley.on('field:error', function() {
        var label = this.$element.closest('.frm_form_field').find('label');
        label.addClass('parsley-error').removeClass('parsley-success');
    });
}

documentReady(function($, Lum) {

    addPlaceholderOnSelect($('form.form-default select'));

    $(function () { objectFitImages(); });

    var body = $('body');
    var isSingleNeutrals = body.hasClass('single-neutrals');
    var isInfoRequestForm = body.hasClass('page-template-page-info-request-form');
    var isRequestARosterForm = body.hasClass('page-template-page-request-a-roster');
    var isContactForm = body.hasClass('page-template-page-contact');
    var isSubmitACaseForm = body.hasClass('page-template-page-submit-a-case-form');
    var luminaParsleyForm = $('form.lumina-parsley');
    var ajaxForm = $('form.frm_ajax_submit');

    var tweetSlick = $('.tweet-slide').not('.slick-initialized');
    if (tweetSlick.length) {
        Lum.slick(
            tweetSlick,
            {
                infinite:true,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:false,
                arrows: true,
                nextArrow: '.twt-next',
                prevArrow: '.twt-prev',
                centerMode: false,
                centerPadding: '0px',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: false,
                            centerPadding: '0px',
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            centerMode: false,
                            centerPadding: '0px',
                            slidesToShow: 1
                        }
                    }
                ]
            }
        );
    }

    var $document = $(document);
    $document.scroll(function() {
        // menu
        if ($document.scrollTop() >= (250)){
            $("header.site-header").addClass('fixit');
        }else{
            $("header.site-header").removeClass('fixit');
        }
    });

    window.addEventListener('resize', adjustFooterColumns);
    adjustFooterColumns();

    new Masonry(
        document.querySelector('#menu-menu-footer'),
        {
            itemSelector: '#menu-menu-footer>.menu-item',
            columnWidth: '#menu-menu-footer>.menu-item',
            percentPosition: true
        }
    );

    $('.share-social-menu a').on('click', function(e) {
        e.preventDefault();
        window.open($(this).attr('href'), '_blank', 'menubar=1,resizable=1,width=600,height=450' );
    });

    $('.read-more-wrapper').find('.read-more').on('click', function (e) {
        e.preventDefault();
        var me = $(this);
        me.closest('.read-more-wrapper').find('.read-more-collapsed, .read-more-expanded').toggleClass('hidden');
        if (me.data('action') === 'less') {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    });

    $('.tabset').find('a').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.tab-wrapper').find('.tab').css("display","none");
        $($(this).attr('href')).css("display","block");
        $(this).closest('.tab-wrapper').find('.tabset li').removeClass("active");
        $(this).closest('li').addClass("active");
    });

    // ACF Google Maps
    $('.acf-map').each(function(){
        new_map( $(this) );
    });

    if (isSingleNeutrals) {
        window.addEventListener('resize', adjustInformationTabsWidth);
        adjustInformationTabsWidth();
    }

    // Add printing poster images for youtube embeds
    var youtube_embeds = $("iframe[src*='youtube']");
    youtube_embeds.each(function () {
        var me = $(this);
        var youtube_video_id = me.attr('src').match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
        if (youtube_video_id.length === 11) {
            var poster = '//img.youtube.com/vi/'+youtube_video_id+'/hqdefault.jpg';
            me.parent().append('<div class="youtube-poster" style="width: ' + me.width() + 'px; height: 100%; display: none;" ><img src="' + poster + '"><div class="youtube-button"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#212121" fill-opacity="0.8"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></div></div>');}
    });

    if (luminaParsleyForm.length) {
        var additionalCityInput = false;
        var additionalStateInput = false;
        if (isInfoRequestForm) {
            additionalCityInput = '#field_6wy8w';
            additionalStateInput = '#field_x9oko';
        }
        //autoCompleteAddress(additionalCityInput, additionalStateInput);

    }

    jQuery( document ).on( 'frmPageChanged', function() {
        //Use selector again. The previous form is destroyed on page change
        luminaParsleyForm = $('form.lumina-parsley');
        if (luminaParsleyForm.length) {
            Lum.Parsley.bindValidationMethods('focusout');
            luminaParsleyForm.parsley();
            Lum.Mask.initM('keyup');
            //autoCompleteAddress(false, false);

            if (isSubmitACaseForm) {
                console.log('owowow');
                trackVisitedPage(luminaParsleyForm);
                $('#field_nu7uy').on('change', function() {
                    setFirstAndLastFromFullName(this, '#field_4hfbd', '#field_nyx9p');
                });
                addParsleyLabelClasses();

                $('.lumina-date').on('change', function(){
                    $(this).parsley().validate();
                });

                $('.frm_btn_edit').each(function () {
                    var me = $(this);
                    var pageNum = me.data('page-num');
                    var dataPage = $('.frm_rootline ').find('.frm_page_' + pageNum).data('page');
                    me.data('page', dataPage);
                    me.show();
                });

                var pageData = $('#js-formidable-page-data');

                if (pageData.length) {
                    var currentPage = pageData.data('current-page');
                    // the final page is 0.
                    if (currentPage == 0) {
                        // Hide the description
                        $('.hide-description-on-submit .text p').hide();
                    } else {
                        // Show the description, if the user goes back
                        $('.hide-description-on-submit .text p').show();
                    }
                }
            }
        }
    } );

    if (isSubmitACaseForm) {
        submitACaseHideFields = $("input[id^=frm_hide_fields_]");
        trackVisitedPage(luminaParsleyForm);
        addParsleyLabelClasses();
        jQuery( document ).on( 'frmStartFormLoading', function() {
            hideFieldsAndAddLoading($('form.lumina-parsley'));
        });

        checkSubmitACaseFormLoaded();
    }

    if (ajaxForm.length && !isSubmitACaseForm) {
        ajaxForm.on('submit', function(e) {
            var form = $(this);
            form.parsley().validate();
            if (form.parsley().isValid()){
                /*
                 * Hide the form and add loading animation
                 */
                form.find('.frm_fields_container').hide();
                form.append('<div class="ta-c"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');
            }
        });
    }

    if (isRequestARosterForm) {
        $('#field_kro7w').on('change', function() {
            setFirstAndLastFromFullName(this, '#field_b8e5t', '#field_hrvz0');
        });
    }

    if (isInfoRequestForm) {
        $('#field_2ee5b2').on('change', function() {
            setFirstAndLastFromFullName(this, '#field_q2nl4', '#field_flwwf');
        });
        conditionalOtherInput($('#field_od22u2'), $('#field_4mo432'), 'Other');
    }

    if (isContactForm) {
        conditionalOtherInput($('#field_ict30'), $('#field_9tva'), 'Other (please explain below)');
    }

    $('.lightbox-go').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
                },
            }
        },
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });


    var instagramSection = $('#sb_instagram');
    if (instagramSection.length) {
        var instagramInitiated = false;

        $(window).on('scroll', function () {
            if (instagramInitiated) {
                return;
            }

            if (isInViewport(document.querySelector('#sb_instagram'))) {
                instagramInitiated = true;
                loadInstagram(instagramSection);
            }
        });

        if (isInViewport(document.querySelector('#sb_instagram'))) {
            instagramInitiated = true;
            loadInstagram(instagramSection);
        }
    }

    var coockieHolder = document.getElementById('cookiebanner');
    // Get the modal
    var modalContainer = document.getElementById("myModal");

    // Get the button that opens the modal
    var modalBtn = document.getElementById("myModalCoockie");
    console.log(modalBtn);

    // Get the <span> element that closes the modal
    var spanBtn = document.getElementsByClassName("close")[0];

    // When the user clicks the button, open the modal 
    // modalBtn.onclick = function() {
    //     modalContainer.style.display = "block";
    //     coockieHolder.style.display = "none";
    // }

    // When the user clicks on <span> (x), close the modal
    spanBtn.onclick = function() {
        modalContainer.style.display = "none";
    }

    var allAccess = document.getElementById('CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection');


    allAccess.addEventListener('click',function(){
        modalContainer.style.display = "none";
    });

});


// When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//     if (event.target == modal) {
//         modal.style.display = "none";
//     }
// }



document.getElementById('practice-areas-btn').addEventListener('click',function(element){
    var elementUl = document.getElementsByClassName('practice-areas-class')[0].childNodes;
    var subMenu = elementUl[2];
    var toogle = subMenu.classList.toggle('active');
    if(toogle === false){
            this.textContent = 'See more...';
    }else {
            this.textContent = 'See less...';
    }
});


function carousel_preload($container){
    $container.on('init', function (event, slick) {
        if($container.hasClass("slick-initialized")){
            $container.parent().find(".preloader").addClass('slick-initialized');
        }
   });
}


documentReady(function($, Lum){   
    carousel_preload($('#news_events-new'));
    carousel_preload($('#new-neutrals-carousel'));

   if($('#new-neutrals-carousel').length>0){
        lmn_slick_slider_init($('#new-neutrals-carousel'), {
            dots: true,
            infinite: true,
            autoplay: false,
            pauseOnHover: false,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 3,
            appendDots: $(".slide-m-dots-neturals"),
            prevArrow: $(".slide-m-prev-neutrals")[0],
            nextArrow: $(".slide-m-next-neutrals")[0],
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        dots: true,
                        slidesToShow: 2,
                        slidesToScroll:2,
                        prevArrow: $(".slide-m-prev-neutrals")[0],
                        nextArrow: $(".slide-m-next-neutrals")[0],
                        appendDots: $(".slide-m-dots-neturals"),
                        infinite: true,
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow: $(".slide-m-prev-neutrals")[0],
                        nextArrow: $(".slide-m-next-neutrals")[0],
                        appendDots: $(".slide-m-dots-neturals"),
                        infinite: true,
                    }
                }, 
            ]
        });
    }


    if($('#news_events-new').length>0){
        // Mobile version slider
        lmn_slick_slider_init($('#news_events-new'), {
            dots: true,
            infinite: true,
            autoplay: false,
            pauseOnHover: false,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 3,
            appendDots: $(".slide-m-dots"),
            prevArrow: jQuery(".slide-m-prev-events")[0],
            nextArrow: jQuery(".slide-m-next-events")[0],
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        appendDots: $(".slide-m-dots"),
                        prevArrow: jQuery(".slide-m-prev-events")[0],
                        nextArrow: jQuery(".slide-m-next-events")[0],
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        appendDots: $(".slide-m-dots"),
                        prevArrow: jQuery(".slide-m-prev-events")[0],
                        nextArrow: jQuery(".slide-m-next-events")[0],
                    }
                }
            ]
        });
    }
});

documentReady(function($, Lum){
    if($('#client-logo-slider-inner').length>0){
        lmn_slick_slider_init($('#client-logo-slider-inner'), {
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 3000,
            cssEase: 'linear',
            prevArrow: false,
            nextArrow: false,
            infinite: true,
            variableWidth: true,
            lazyLoad: 'ondemand',
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
});


window.addEventListener('resize', function() {
    Lum.blazyRevalidate();
});

const btnMobile = document.getElementById('searchClickMobile');

btnMobile.addEventListener('click', function(){
    const form = document.getElementById('myDropdownMobile');
    if (form.style.display === 'none') {
        form.style.display = 'block';
    } else {
        form.style.display = 'none';
    }
    document.getElementById("searchFilter").focus();
});


const btn = document.getElementById('searchClick');
const dropdown = document.getElementById('dropdown');

btn.addEventListener('click', function(){
    const form = document.getElementById('myDropdown');
    if (form.style.display === 'none') {
        form.style.display = 'block';
    } else {
        form.style.display = 'none';
    }
    document.getElementById("searchFilter").focus();
});


const form = document.getElementById('myDropdown');
const formDropDown = document.getElementById('myDropdownMobile');
document.body.addEventListener("click", function(e) {
    
    var target = e.target || e.srcElement;
    if (target !== form && !isChildOf(target, form) && target !== btn  ) {
        form.style.display = 'none';
    }

    if (target !== formDropDown && !isChildOf(target, formDropDown) && target !== btnMobile  ) {
        formDropDown.style.display = 'none';
    }
  }, 
false);



function isChildOf(child, parent) {
    if (child.parentNode === parent) {
        return true;
    } else if (child.parentNode === null) {
        return false;
    } else {
        return isChildOf(child.parentNode, parent);
    }
  }



$('#dropdownMobile #searchFilter').on('input', function() {
    var query = $('#dropdownMobile #searchFilter').val();
    var ajaxscript = { ajax_url : '/wp/wp-admin/admin-ajax.php' }
       
    if (query.length > 2) {
        $.ajax({
            type: 'GET',
            url : ajaxscript.ajax_url,
            dataType: 'json',
            data: {
                action: 'ajax_search',
                query: query
            },
            success: function(response) {
                console.log('dali ima voopsoto nesto');
                if (response) {
                    var suggestions_html = '<ul class="search-suggestions">';
                    $.each(response, function(index, value) {
                        if (value.length > 0){
                            suggestions_html  += '<li class="sub-holder"><span>'+index+'</span><ul class="lists">';
                            $.each(value, function(index, meta) {
                                suggestions_html  += '<li class="sub-list"><a class="link-post" href="'+meta.url+'">'+ meta.title +'</a><li>';
                            })
                            suggestions_html  += '</ul></li>';
                        }
                        
                    });
                    // Add "See more" button if more than 5 results
                                
                    const postTypes = ['neutrals', 'post', 'page']; // replace with your desired post types
                    const searchUrl = window.location.origin+"/?s="+encodeURIComponent(query);

                    // suggestions_html += '<li class="see-more"><a href="' + searchUrl + '">' + 'See more' + '</a></li>';
                    
                    suggestions_html += '</ul>';
                    $('#suggestions-mobile').html(suggestions_html);
                } else {
                    $('#suggestions-mobile').empty();
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });
    } else {
        $('#suggestions-mobile').empty();
    }
});


$('#searchFilter').on('input', function() {
    var query = $('#searchFilter').val();
    var ajaxscript = { ajax_url : '/wp/wp-admin/admin-ajax.php' }
       
    if (query.length > 2) {
        $.ajax({
            type: 'GET',
            url : ajaxscript.ajax_url,
            dataType: 'json',
            data: {
                action: 'ajax_search',
                query: query
            },
            success: function(response) {
                if (response) {
                    var suggestions_html = '<ul class="search-suggestions">';
                    $.each(response, function(index, value) {
                        if (value.length > 0){
                            suggestions_html  += '<li class="sub-holder"><span>'+index+'</span><ul class="lists">';
                            $.each(value, function(index, meta) {
                                suggestions_html  += '<li class="sub-list"><a class="link-post" href="'+meta.url+'">'+ meta.title +'</a><li>';
                            })
                            suggestions_html  += '</ul></li>';
                        }
                        
                    });
                    // Add "See more" button if more than 5 results
                                
                    const postTypes = ['neutrals', 'post', 'page']; // replace with your desired post types
                    const searchUrl = window.location.origin+"/?s="+encodeURIComponent(query);

                    // suggestions_html += '<li class="see-more"><a href="' + searchUrl + '">' + 'See more' + '</a></li>';
                    
                    suggestions_html += '</ul>';
                    $('#suggestions').html(suggestions_html);
                } else {
                    $('#suggestions').empty();
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });
    } else {
        $('#suggestions').empty();
    }
});

$(document).on('click', '#suggestions li', function() {
    var suggestion = $(this).text();
    $('#search').val(suggestion);
    $('#search-form').submit();
});
$(document).on('click', '#button_submit_case', function() {
   
    $('#hide-on-submit').hide();});
